import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { stripeService } from '../../lib/stripe';
import { supabase } from '../../lib/supabase';
import { useToast } from '../../components/ui/use-toast';

const StripeSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        // Récupérer le payment_intent de l'URL
        const paymentIntent = searchParams.get('payment_intent');
        if (!paymentIntent) {
          throw new Error('Payment Intent non trouvé');
        }

        // Trouver d'abord la transaction
        const { data: transaction, error: fetchError } = await supabase
          .from('transactions')
          .select('*, contestants(contests(slug))')
          .eq('payment_reference', paymentIntent)
          .single();

        if (fetchError || !transaction) {
          console.error('Erreur lors de la récupération de la transaction:', fetchError);
          throw new Error('Transaction non trouvée');
        }

        console.log('Transaction trouvée:', transaction);

        // Vérifier le paiement avec Stripe
        const paymentStatus = await stripeService.verifyPayment(paymentIntent);
        console.log('Statut du paiement:', paymentStatus);

        if (paymentStatus.status === 'completed') {
          // Préparer les données de mise à jour
          const updateData = {
            status: 'completed',
            payment_data: paymentStatus.payment_data,
            updated_at: new Date().toISOString(),
            phone_number: '23767111111111' // Numéro par défaut pour Stripe
          };

          console.log('Données de mise à jour:', updateData);

          // Mettre à jour la transaction dans la base de données
          const { error: updateError } = await supabase
            .from('transactions')
            .update(updateData)
            .eq('payment_reference', paymentIntent)
            .select();

          if (updateError) {
            console.error('Erreur lors de la mise à jour de la transaction:', updateError);
            throw new Error(`Erreur de mise à jour: ${updateError.message}`);
          }

          // Vérifier que la mise à jour a bien été effectuée
          const { data: updatedTransaction, error: checkError } = await supabase
            .from('transactions')
            .select('status')
            .eq('payment_reference', paymentIntent)
            .single();

          if (checkError || !updatedTransaction) {
            console.error('Erreur lors de la vérification de la mise à jour:', checkError);
            throw new Error('Impossible de vérifier la mise à jour de la transaction');
          }

          console.log('Transaction mise à jour:', updatedTransaction);

          if (updatedTransaction.status !== 'completed') {
            throw new Error('Le statut de la transaction n\'a pas été mis à jour correctement');
          }

          toast({
            title: "Paiement réussi !",
            description: "Vos votes ont été comptabilisés.",
            variant: "default",
          });

          // Rediriger vers la page du concours
          const contestSlug = transaction.contestants?.contests?.slug;
          if (contestSlug) {
            navigate(`/c/${contestSlug}`);
          } else {
            navigate('/contests');
          }
        } else {
          throw new Error('Le paiement a échoué');
        }
      } catch (err) {
        console.error('Erreur lors de la vérification du paiement:', err);
        toast({
          title: "Erreur de paiement",
          description: err instanceof Error ? err.message : 'Une erreur est survenue',
          variant: "destructive",
        });
        setTimeout(() => navigate('/payment/cancel'), 2000);
      }
    };

    verifyPayment();
  }, [searchParams, navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-2xl font-bold text-green-600 mb-4">
          Vérification du paiement
        </h1>
        <p className="text-gray-600">Veuillez patienter pendant que nous vérifions votre paiement...</p>
      </div>
    </div>
  );
};

export default StripeSuccess;
